function getTimezoneAbbreviation(date, timezone) {
  try {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: timezone,
      timeZoneName: "short",
    }).formatToParts(date);
    return parts.find((p) => p.type === "timeZoneName")?.value || "";
  } catch (e) {
    return "";
  }
}

function formatCourseDateTimeForDropdown(
  courseStartDateTime,
  remainingSeats,
  maxSeats,
  timezone
) {
  if (!courseStartDateTime) return "";
  const [dateTimeString, sequenceId] = courseStartDateTime.split("|");
  // Parse the input string into a Date object
  const date = new Date(dateTimeString);

  const dateParts = date.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  const time = date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  // Get timezone abbreviation (e.g. "EST", "PST")
  const tzAbbrev = timezone ? getTimezoneAbbreviation(date, timezone) : "";
  const timeWithTz = tzAbbrev ? `${time} ${tzAbbrev}` : time;

  // Build the final string
  return `${dateParts} – ${timeWithTz} (${remainingSeats} of ${maxSeats} left )`;
}

function formatCourseDateTime(sessionDateTime) {
  if (!sessionDateTime) return "";
  const [dateTimeString, sequenceId] = sessionDateTime.split("|");

  const date = new Date(dateTimeString); //format: "2025-08-31T12:00"

  const dateParts = date.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  const time = date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  return `${dateParts} – ${time}`;
}
function convertRRuleToDescription(rrule, startDate, endDate) {
  const rules = {};
  const parts = rrule.split(";");

  parts.forEach((part) => {
    const [key, value] = part.split("=");
    rules[key] = value;
  });

  let description = "Classes ";

  const freq = rules.FREQ;
  const interval = parseInt(rules.INTERVAL) || 1;

  if (freq === "WEEKLY") {
    if (interval === 1) {
      description += "every ";
    } else {
      description += `every ${interval} weeks on `;
    }
  } else if (freq === "DAILY") {
    if (interval === 1) {
      description += "daily";
    } else {
      description += `every ${interval} days`;
    }
  } else if (freq === "MONTHLY") {
    if (interval === 1) {
      description += "monthly";
    } else {
      description += `every ${interval} months`;
    }
  }

  if (rules.BYDAY && freq === "WEEKLY") {
    const dayMap = {
      MO: "Mon",
      TU: "Tue",
      WE: "Wed",
      TH: "Thu",
      FR: "Fri",
      SA: "Sat",
      SU: "Sun",
    };

    const dayAbbrevs = rules.BYDAY.split(",");

    const weekdays = ["MO", "TU", "WE", "TH", "FR"];
    const isAllWeekdays =
      weekdays.length === dayAbbrevs.length &&
      weekdays.every((day) => dayAbbrevs.includes(day));

    if (isAllWeekdays) {
      description += "weekday";
    } else {
      const days = dayAbbrevs.map((day) => dayMap[day] || day);

      if (days.length === 1) {
        description += `${days[0]}`;
      } else if (days.length === 2) {
        description += `${days[0]} and ${days[1]}`;
      } else {
        const lastDay = days.pop();
        description += `${days.join(", ")}, and ${lastDay}`;
      }
    }
  }

  if (startDate && endDate) {
    const startdateparts = startDate.split("-");
    const start = new Date(
      Number(startdateparts[0]),
      Number(startdateparts[1]) - 1,
      Number(startdateparts[2]),
      0,
      0,
      0
    );
    const enddateparts = endDate.split("-");

    const end = new Date(
      Number(enddateparts[0]),
      Number(enddateparts[1]) - 1,
      Number(enddateparts[2]),
      23,
      59,
      59
    );

    // Calculate number of weeks
    const timeDiff = end.getTime() - start.getTime();
    const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
    const weeks = Math.ceil(daysDiff / 7);

    // Format start date
    const startFormatted = start.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });

    description += ` for ${weeks} ${
      weeks === 1 ? "week" : "weeks"
    } starting on ${startFormatted}`;
  } else if (startDate) {
    const dateparts = startDate.split("-");
    const start = new Date(
      Number(dateparts[0], Number(dateparts[1]) - 1, dateparts[2])
    );
    const startFormatted = start.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
    description += ` starting on ${startFormatted}`;
  }

  return description;
}
export {
  formatCourseDateTimeForDropdown,
  formatCourseDateTime,
  convertRRuleToDescription,
};
